export default class PredictorExplainer {
  constructor(level, explainerType, svg, title) {
    this.level = level;
    this.explainerType = explainerType;
    this.svg = svg;
    this.title = title;
  }
}